// @ts-ignore
import SparkMD5 from 'spark-md5';
import { Message } from 'element-ui';
import { IOrderForm } from '@/types/placeOrderTypes';
import { IServiceMap } from '@/business/BusinessFormData';
import { ICustomerAppKey, IOrganization } from '@/store/state';
import { ServiceContentEnum } from '@/business/ServiceContent';
export const getFileMd5 = async (file: File) => {
  // 这里需要用到File的slice( )方法，以下是兼容写法
  const blobSlice = File.prototype.slice;
  const chunkSize = 2097152; // 以每片2MB大小来逐次读取
  const chunks = Math.ceil(file.size / chunkSize);
  let currentChunk = 0;
  const spark = new SparkMD5(); // 创建sparkMD5的实例
  const fileReader = new FileReader();
  const loadNext = async () => {
    const start = currentChunk * chunkSize;
    const end = start + chunkSize >= file.size ? file.size : start + chunkSize;
    await fileReader.readAsBinaryString(blobSlice.call(file, start, end));
  };
  return new Promise((resolve) => {
    fileReader.onload = (e) => {
      spark.appendBinary((e as any).target.result); // append array buffer
      currentChunk += 1;
      if (currentChunk < chunks) {
        loadNext();
      } else {
        resolve(spark.end());
        return spark.end(); // 完成计算，返回结果
      }
    };
    fileReader.onerror = () => {
      Message.error('读取文件MD5值失败！');
    };
    loadNext();
  });
};

export const handleUrl = (url: string) => {
  const check = ['+'];
  check.forEach(item => {
    url = url.replaceAll(item, encodeURIComponent(item));
  });
  return url;
};

export const add0 = (m: number) => {
  return m < 10 ? '0' + m : m;
};

export const getDeadLineTime = () => {
  const timestamp = new Date().getTime() + 14 * 24 * 3600 * 1000;
  const time = new Date(timestamp);
  const y = time.getFullYear();
  const m = time.getMonth() + 1;
  const d = time.getDate();
  return y + '-' + add0(m) + '-' + add0(d);
};

export const getDefaultForm = (
  serviceType?: string,
  formInfo?: IServiceMap,
  organization?: IOrganization,
  customerAppKey?: ICustomerAppKey,
  name?: string,
) => {
  const defaultForm: IOrderForm = {
    app_key: '',
    deadline: getDeadLineTime(),
    tag: { priority_tag: -1 },
    service_content: 0,
    customer_id: '',
    customer_name: '',
    status: 0,
    grade_uid: '',
    subject: '',
    stage: '',
    alias: '',
    book_name: '',
    source: 1,
    material: {
      type: 0,
      oss_fbd_zips: [],
      oss_zip_files: [],
      oss_image_zips: [],
      oss_word_files: [],
      oss_json_files: [],
      oss_pdf_files: [],
      oss_ppt_files: [],
      oss_images: [],
      content_desc: '',
      courseware_sample_files: [],
      courseware_sample_desc: '',
    },
    xdoc_planning: [],
  };

  // 如果没有传递必要参数，直接返回默认表单
  if (!serviceType || !formInfo || !organization || !customerAppKey || !name) {
    return defaultForm;
  }

  if (formInfo.category !== 'courseware' && formInfo.formData.service_content != 25) {
    defaultForm.alias = `${organization.orgName}-${name}`;
  }
  defaultForm.app_key = customerAppKey.appKey;
  defaultForm.customer_id = organization.id + '';
  defaultForm.customer_name = organization.orgName;
  defaultForm.service_content = formInfo.formData.service_content;
  defaultForm.material.type = formInfo?.formData.material?.type || 0;

  // 根据 serviceContent 添加特定配置
  if (formInfo.formData.service_content === 25) {
    defaultForm.config = {
      is_convert_image: false,
      is_convert_latex_to_image: false,
      is_convert_table_to_image: false,
    };
  }

  return defaultForm;
};
